/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Label_PhoneInputs */

const en_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone`)
};

const es_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teléfono`)
};

const de_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const zh_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电话`)
};

const ar_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الهاتف`)
};

const fr_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléphone`)
};

const vi_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điện thoại`)
};

const sw_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simu`)
};

const th_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โทรศัพท์`)
};

const bs_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const ja_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電話番号`)
};

const ko_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전화`)
};

const pt_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefone`)
};

const it_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefono`)
};

const sv_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const nl_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefoon`)
};

const da_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const nb_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const fi_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puhelin`)
};

const pl_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const ru_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Телефон`)
};

const tr_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const hi_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोन`)
};

const id_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telepon`)
};

const ms_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const cs_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const el_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τηλέφωνο`)
};

const he_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טלפון`)
};

const af_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefoon`)
};

const hu_booking_label_phone = /** @type {(inputs: Booking_Label_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

/**
* | output |
* | --- |
* | "Phone" |
*
* @param {Booking_Label_PhoneInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_label_phone = /** @type {((inputs?: Booking_Label_PhoneInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Label_PhoneInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_label_phone(inputs)
	if (locale === "de") return de_booking_label_phone(inputs)
	if (locale === "zh") return zh_booking_label_phone(inputs)
	if (locale === "ar") return ar_booking_label_phone(inputs)
	if (locale === "fr") return fr_booking_label_phone(inputs)
	if (locale === "vi") return vi_booking_label_phone(inputs)
	if (locale === "sw") return sw_booking_label_phone(inputs)
	if (locale === "th") return th_booking_label_phone(inputs)
	if (locale === "bs") return bs_booking_label_phone(inputs)
	if (locale === "ja") return ja_booking_label_phone(inputs)
	if (locale === "ko") return ko_booking_label_phone(inputs)
	if (locale === "pt") return pt_booking_label_phone(inputs)
	if (locale === "it") return it_booking_label_phone(inputs)
	if (locale === "sv") return sv_booking_label_phone(inputs)
	if (locale === "nl") return nl_booking_label_phone(inputs)
	if (locale === "da") return da_booking_label_phone(inputs)
	if (locale === "nb") return nb_booking_label_phone(inputs)
	if (locale === "fi") return fi_booking_label_phone(inputs)
	if (locale === "pl") return pl_booking_label_phone(inputs)
	if (locale === "ru") return ru_booking_label_phone(inputs)
	if (locale === "tr") return tr_booking_label_phone(inputs)
	if (locale === "hi") return hi_booking_label_phone(inputs)
	if (locale === "id") return id_booking_label_phone(inputs)
	if (locale === "ms") return ms_booking_label_phone(inputs)
	if (locale === "cs") return cs_booking_label_phone(inputs)
	if (locale === "el") return el_booking_label_phone(inputs)
	if (locale === "he") return he_booking_label_phone(inputs)
	if (locale === "af") return af_booking_label_phone(inputs)
	if (locale === "hu") return hu_booking_label_phone(inputs)
	return en_booking_label_phone(inputs)
});